import { FormFieldsStep } from "../commos/FormStep";
import { createLegalSchema } from "@/schemas/legal/legal";
import { useLegalContext } from "@/contexts/legalContext";
import { useLegalsFields } from '@/hooks/legals/useLegalsFields';


export const FirstStepLegal = () => {
    const { onComplete, isFetching } = useLegalContext();
    const { fields } = useLegalsFields();

    return (
        <FormFieldsStep
            schema={createLegalSchema}
            defaultValues={{
                name: "",
                legal_text: "",
                color: "",
            }}
            fields={fields as any}
            onComplete={onComplete}
            isFetching={isFetching}
            formId="legal-general-info"
            description="Aquí podrás ingresar la información correspondiente a tu legal"
            className="px-10 pt-3 pb-6"
        />
    );
};